import { Controller } from "@hotwired/stimulus"

// Inline editing for card steps
export default class extends Controller {
  static targets = ["text", "form", "input"]

  connect() {
    // Ensure we're not in edit mode on connect
    this.exitEditMode()
  }

  // Enter edit mode
  edit(event) {
    event.preventDefault()

    // Hide text, show form
    this.textTarget.classList.add("hidden")
    this.formTarget.classList.remove("hidden")

    // Focus the input and select all text
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  // Exit edit mode (cancel)
  cancel(event) {
    event.preventDefault()
    this.exitEditMode()
  }

  // Handle form submission
  submit(event) {
    // Let the form submit naturally via Turbo
    // The turbo:submit-end event will handle cleanup
  }

  // Exit edit mode helper
  exitEditMode() {
    if (this.hasTextTarget && this.hasFormTarget) {
      this.textTarget.classList.remove("hidden")
      this.formTarget.classList.add("hidden")
    }
  }

  // Handle successful submission
  submitSuccess() {
    this.exitEditMode()
  }

  // Handle failed submission
  submitError() {
    // Keep form open on error so user can fix
    this.inputTarget.focus()
  }
}
